import { animeList } from "@/mocks/animeData";

function Featured() {
  const top = animeList.slice(0, 6);

  return (
    <section id="featured" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8 md:mb-10">
          <div>
            <span className="text-xs font-semibold tracking-widest text-primary-600 uppercase">
              Featured
            </span>
            <h2 className="mt-2 font-heading text-2xl md:text-4xl text-foreground-950">
              热门治愈番推荐
            </h2>
            <p className="mt-2 max-w-xl text-sm md:text-base text-foreground-700">
              编辑部精挑的高分治愈代表作，评分与人气都在线，放心入坑。
            </p>
          </div>
          <a
            href="#categories"
            className="inline-flex whitespace-nowrap items-center gap-1.5 rounded-full border border-primary-200 px-4 py-2 text-sm font-medium text-primary-700 hover:bg-primary-50 transition-colors"
          >
            查看全部分类
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {top.map((a) => (
            <article
              key={a.id}
              className="group overflow-hidden rounded-lg bg-background-100 border border-background-200/70 hover:border-primary-200 transition-colors"
            >
              <div className="relative aspect-[4/3] w-full overflow-hidden">
                <img
                  src={a.image}
                  alt={`${a.title} 治愈系动画推荐`}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-background-50/90 px-2.5 py-1 text-xs font-medium text-primary-700 backdrop-blur-sm">
                  {a.score} 分
                </span>
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center justify-between gap-2">
                  <h3 className="font-heading text-lg md:text-xl text-foreground-950 whitespace-nowrap">
                    {a.title}
                  </h3>
                  <span className="text-xs text-foreground-600 whitespace-nowrap">
                    {a.jpTitle}
                  </span>
                </div>
                <div className="mt-3 flex flex-wrap gap-1.5">
                  {a.mood.map((m) => (
                    <span
                      key={m}
                      className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs text-secondary-900"
                    >
                      {m}
                    </span>
                  ))}
                </div>
                <p className="mt-3 line-clamp-2 text-sm leading-relaxed text-foreground-700">
                  {a.desc}
                </p>
                <div className="mt-4 flex items-center gap-3 text-xs text-foreground-600">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-focus-3-line text-primary-600"></i>
                    {a.studio}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-calendar-line text-primary-600"></i>
                    {a.year}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-play-list-2-line text-primary-600"></i>
                    {a.episodes}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Featured;